import styled from "styled-components";
import { mediaMin } from "utils/theme";

export const ContentWrapper = styled.div`
  ${mediaMin("md")} {
    padding-top: 82px;
  }
`;
